module.exports = __webpack_public_path__ + "img/store_vip_benefit_order.ed763864.png";